// extracted by mini-css-extract-plugin
module.exports = {"description":"_5da12__index-module__description"};